import { useQuery } from "@tanstack/react-query";
import { getBackendUrl } from "api/common";
import { axiosClient } from "api/http/config";
import { useQueryWithInternalMessages } from "features/CenterContent/RoleContent/InternalMessage/utils/withInternalMessages";
import {
  InfrastructureResponse,
  upcomingEventsResponseSchema,
} from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/types/responseSchema";
import { upcomingEventsQueryKey } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/UpcomingEventsModal/EventsOverviewButtonAndModal";
import { getDisplayDurationStringFromUnparsedResponse } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/UpcomingEventsModal/utils";
import { useCountryCodeForDropsRole } from "shared/hooks/useCountryCodeForDropsRole";
import { useParseResultContext } from "shared/utils/useParseResult";

export const useUpcommingInfrastructureMessages = () => {
  const { handleParse } = useParseResultContext();
  const parse = handleParse(
    (response: InfrastructureResponse) => [
      response.stretchName,
      getDisplayDurationStringFromUnparsedResponse(response),
    ],
    "infrastructure",
  );
  const countryCode = useCountryCodeForDropsRole();
  return {
    upcomingInfrastructureEvents: useQueryWithInternalMessages(
      useQuery({
        queryKey: upcomingEventsQueryKey(countryCode),
        staleTime: 0,
        queryFn: ({ signal }) =>
          axiosClient
            .get<InfrastructureResponse[]>(
              `${getBackendUrl()}/infrastructure-event/upcoming?countryCode=${countryCode}`,
              {
                signal,
              },
            )
            .then((res) => parse(upcomingEventsResponseSchema, res.data)),
      }),
    ),
  };
};
